let companyDB = [
  {
    'company_id': '183335a7f3a911e89388204747b14756',
    'company_num': '201811298117',
    'user_id': 'provider-uuid',
    'company_name': '北京互联港湾科技有限公司',
    'company_nature': '有限责任公司(自然人投资或控股)',
    'register_captial': '3000',
    'company_address': '北京互联港湾科技有限公司的地址',
    'company_website': '无',
    'organize_code': '91310000398752340E',
    'license_code': '91310000398752340E',
    'founding_time': '3/7/2014',
    'operating_period': '2/7/2034',
    'main_business': '投资管理，资产管理，实业投资。 【依法须经批准的项目，经相关部门批准后方可开展经营活动】',
    'legal_representative': '互联港湾',
    'bank_name': '中国建设银行',
    'bank_account': '1111222233334444111',
    'superior_company': '无',
    'register_code': '91310000398752340E',
    'total_employee': '100',
    'total_asset': '1000',
    'net_asset': '100',
    'flag': '0'
  },
  {
    'company_id': '18334868f3a911e89388204747b14756',
    'company_num': '201811296126',
    'user_id': 'provider1-uuid',
    'company_name': '北京工商局',
    'company_nature': '有限责任公司(自然人独资)',
    'register_captial': '100',
    'company_address': '北京工商局的地址',
    'company_website': '无',
    'organize_code': '91110108MA00DDDQ9B',
    'license_code': '91110108MA00DDDQ9B',
    'founding_time': '11/4/2017',
    'operating_period': '10/4/2037',
    'main_business': '技术开发；销售自行开发的产品；销售计算机、软件及辅助设备、通讯设备、金属材料、建筑材料（不从事实体店铺经营）、五金交电（不从事实体店铺经营）、机械设备、化工产品（不含危险化学品及一类易制毒化学品）、食品添加剂、医疗器械Ⅰ类、文化用品、日用品；经济贸易咨询；企业管理咨询；销售食品。（企业依法自主选择经营项目，开展经营活动；销售食品以及依法须经批准的项目，经相关部门批准后依批准的内容开展经营活动；不得从事本市产业政策禁止和限制类项目的经营活动。）',
    'legal_representative': '工商局',
    'bank_name': '中国建设银行',
    'bank_account': '1111222233334444111',
    'superior_company': '无',
    'register_code': '91110108MA00DDDQ9B',
    'total_employee': '100',
    'total_asset': '1000',
    'net_asset': '100',
    'flag': '0'
  },
  {
    'company_id': '18334cc7f3a911e89388204747b14756',
    'company_num': '201811295278',
    'user_id': 'provider-uuid',
    'company_name': '腾讯云',
    'company_nature': '股份有限公司(中外合资、上市)',
    'register_captial': '609740',
    'company_address': '腾讯云的地址',
    'company_website': 'https://www.haier.com/cn/',
    'organize_code': '91370200264574251E',
    'license_code': '91370200264574251E',
    'founding_time': '31/3/1994',
    'operating_period': '',
    'main_business': '电器、电子产品、机械产品、通讯设备及相关配件、工业自动化控制设备、计算机软硬件及辅助设备的研发与制造；家用电器及电子产品技术咨询服务；进出口业务（按外经贸部核准范围经营）；批发零售：国内商业（国家禁止商品除外）；从事数字科技、智能科技、软件科技；技术开发、技术咨询、技术转让、技术服务（包含工业互联网及家电产品等）；数据处理;应用软件开发及服务；先进控制与优化技术的开发与应用研究；矿泉水制造、饮食、旅游服务（限分支机构经营)；企业管理服务及咨询、信息技术服务。',
    'legal_representative': '腾讯',
    'bank_name': '中国建设银行',
    'bank_account': '1111222233334444111',
    'superior_company': '无',
    'register_code': '91370200264574251E',
    'total_employee': '100',
    'total_asset': '1000',
    'net_asset': '100',
    'flag': '0'
  },
  {
    'company_id': '83c1f066f3a711e89388204747b14756',
    'company_num': '201811295282',
    'user_id': 'provider-uuid',
    'company_name': '联想',
    'company_nature': '有限责任公司(自然人投资或控股)',
    'register_captial': '30',
    'company_address': '联想的地址',
    'company_website': '无',
    'organize_code': '9136110206972762X5',
    'license_code': '9136110206972762X5',
    'founding_time': '3/6/2013',
    'operating_period': '2/6/2033',
    'main_business': '服装、婴幼儿用品批发、零售。(以上项目国家有专项规定凭许可证或资质证经营)',
    'legal_representative': '联想',
    'bank_name': '中国银行',
    'bank_account': '1111222233334444111',
    'superior_company': '无',
    'register_code': '9136110206972762X5',
    'total_employee': '100',
    'total_asset': '1000',
    'net_asset': '500',
    'flag': '0'
  },
  {
    'company_id': '83c2517ff3a711e89388204747b14756',
    'company_num': '201811299854',
    'user_id': 'provider-uuid',
    'company_name': '中国联通',
    'company_nature': '全民所有制',
    'register_captial': '20',
    'company_address': '中国联通的地址',
    'company_website': '无',
    'organize_code': '911303044018253952',
    'license_code': '911303044018253952',
    'founding_time': '1/8/1997',
    'operating_period': '31/7/2037',
    'main_business': '自有房产租赁服务',
    'legal_representative': '联通',
    'bank_name': '中国银行',
    'bank_account': '1111222233334444111',
    'superior_company': '无',
    'register_code': '911303044018253952',
    'total_employee': '100',
    'total_asset': '1000',
    'net_asset': '500',
    'flag': '0'
  },
  {
    'company_id': '83c2c010f3a711e89388204747b14756',
    'company_num': '201811295421',
    'user_id': 'provider-uuid',
    'company_name': '华为云',
    'company_nature': '股份有限公司(上市、国有控股)',
    'register_captial': '2077419',
    'company_address': '华为云的地址',
    'company_website': '无',
    'organize_code': '91350000158142711F',
    'license_code': '91350000158142711F',
    'founding_time': '22/8/1988',
    'operating_period': '21/8/2038',
    'main_business': '吸收公众存款；发放短期、中期和长期贷款；办理国内外结算；办理票据承兑与贴现；发行金融债券；代理发行、代理兑付、承销政府债券；买卖政府债券、金融债券；代理发行股票以外的有价证券；买卖、代理买卖股票以外的有价证券；资产托管业务；从事同业拆借；买卖、代理买卖外汇；结汇、售汇业务；从事银行卡业务；提供信用证服务及担保；代理收付款项及代理保险业务；提供保管箱服务；财务顾问、资信调查、咨询、见证业务；经中国银行业监督管理机构批准的其他业务。(依法须经批准的项目，经相关部门批准后方可开展经营活动)',
    'legal_representative': '华为',
    'bank_name': '中国银行',
    'bank_account': '1111222233334444111',
    'superior_company': '无',
    'register_code': '91350000158142711F',
    'total_employee': '100',
    'total_asset': '1000',
    'net_asset': '500',
    'flag': '0'
  },
  {
    'company_id': '83c360e8f3a711e89388204747b14756',
    'company_num': '201811295544',
    'user_id': 'provider-uuid',
    'company_name': '京东云硬盘',
    'company_nature': '个人独资企业',
    'register_captial': '123',
    'company_address': '京东云硬盘的地址',
    'company_website': '无',
    'organize_code': '91361102095601860T',
    'license_code': '91361102095601860T',
    'founding_time': '24/3/2014',
    'operating_period': '23/3/2044',
    'main_business': '其他粮食加工品（谷物碾磨加工品）销售；味精[谷氨酸钠（99%味精）]（分装）',
    'legal_representative': '京东云',
    'bank_name': '中国银行',
    'bank_account': '1111222233334444111',
    'superior_company': '无',
    'register_code': '91361102095601860T',
    'total_employee': '100',
    'total_asset': '1000',
    'net_asset': '500',
    'flag': '0'
  },
  {
    'company_id': '83c3c017f3a711e89388204747b14756',
    'company_num': '201811291455',
    'user_id': 'provider1-uuid',
    'company_name': '中国电信',
    'company_nature': '有限责任公司(自然人投资或控股)',
    'register_captial': '1000',
    'company_address': '中国电信的地址',
    'company_website': '无',
    'organize_code': '91350203MA2YACL10M',
    'license_code': '91350203MA2YACL10M',
    'founding_time': '7/6/2017',
    'operating_period': '6/6/2067',
    'main_business': '投资管理（法律、法规另有规定除外）；投资咨询（法律、法规另有规定除外）；资产管理（法律、法规另有规定除外）',
    'legal_representative': '电信',
    'bank_name': '中国银行',
    'bank_account': '1111222233334444111',
    'superior_company': '无',
    'register_code': '91350203MA2YACL10M',
    'total_employee': '100',
    'total_asset': '1000',
    'net_asset': '500',
    'flag': '0'
  },
  {
    'company_id': '83c42b07f3a711e89388204747b14756',
    'company_num': '201811297641',
    'user_id': 'provider1-uuid',
    'company_name': '招银金融云',
    'company_nature': '股份有限公司(中外合资、上市)',
    'register_captial': '779405',
    'company_address': '招银金融云的地址',
    'company_website': '无',
    'organize_code': '914300007121944064',
    'license_code': '914300007121944064',
    'founding_time': '31/8/1999',
    'operating_period': '30/8/2029',
    'main_business': '开发、生产、销售工程机械、环卫机械、汽车起重机及其专用底盘、消防车辆及其专用底盘、高空作业机械、其它机械设备、金属与非金属材料、光机电一体化高新技术产品并提供租赁、售后技术服务；销售建筑装饰材料、工程专用车辆及金属材料、化工原料、化工产品（不含危化品和监控品）；经营商品和技术的进出口业务；以自有资产进行房地产业投资（不得从事吸收存款、集资收款、受托贷款、发行票据、发放贷款等国家金融监管及财政信用业务）。二手车销售；废旧机械设备拆解、回收。（依法须经批准的项目，经相关部门批准后方可开展经营活动）',
    'legal_representative': '招银',
    'bank_name': '中国银行',
    'bank_account': '1111222233334444111',
    'superior_company': '无',
    'register_code': '914300007121944064',
    'total_employee': '100',
    'total_asset': '1000',
    'net_asset': '500',
    'flag': '0'
  },
  {
    'company_id': '83c48f4bf3a711e89388204747b14756',
    'company_num': '201811295842',
    'user_id': 'provider-uuid',
    'company_name': '用友：协同云',
    'company_nature': '有限责任公司(自然人投资或控股)',
    'register_captial': '200',
    'company_address': '用友的地址',
    'company_website': '无',
    'organize_code': '91430103397564284K',
    'license_code': '91430103397564284K',
    'founding_time': '3/6/2014',
    'operating_period': '2/6/2064',
    'main_business': '投资管理；投资咨询；商务信息咨询；财务咨询；企业并购、重组策划；会议服务；企业形象设计、策划；企业营销策划；软件开发；计算机软件及辅助设备、电子产品的销售。（依法须经批准的项目，经相关部门批准后方可开展经营活动）',
    'legal_representative': '用友',
    'bank_name': '中国银行',
    'bank_account': '1111222233334444111',
    'superior_company': '无',
    'register_code': '91430103397564284K',
    'total_employee': '100',
    'total_asset': '1000',
    'net_asset': '500',
    'flag': '0'
  },
  {
    'company_id': 'ce92c1f4e97311e8a28a204747b14756',
    'company_num': '201811226385',
    'user_id': 'provider-uuid',
    'company_name': '百度云：对象存储',
    'company_nature': '有限责任公司(自然人独资)',
    'register_captial': '500',
    'company_address': '百度云：对象存储的地址',
    'company_website': 'http://www.frontsurf.com/',
    'organize_code': '91440300MA5DQD7P4M',
    'license_code': '91440300MA5DQD7P4M',
    'founding_time': '8/12/2016',
    'operating_period': '8/12/2036',
    'main_business': '计算机软件开发、设计、系统集成',
    'legal_representative': '百度云',
    'bank_name': '中国银行',
    'bank_account': '1111222233334444111',
    'superior_company': '无',
    'register_code': '91440300MA5DQD7P4M',
    'total_employee': '100',
    'total_asset': '1000',
    'net_asset': '500',
    'flag': '0'
  }
]

export { companyDB }
